
const SECTION_ID = 'shopify-section-template--19144638136474__section_cYz7nz';
const SELECTOR_SLIDE = '.image-block';
const AUTOPLAY = true;
const AUTOPLAY_INTERVAL = 8000; // ms
const TRANSITION_MS = 180; // ms
const SWIPE_THRESHOLD = 40; // px

// ---- helpers
const hasInitFlag = (el) => el && el.dataset.csSliderInit === '1';
const setInitFlag = (el) => { el.dataset.csSliderInit = '1'; };

function onShopifySectionLoad(cb) {
  document.addEventListener('shopify:section:load', (e) => {
    const section = e.target;
    if (section && section.id && section.querySelector(SELECTOR_SLIDE)) {
      cb(section);
    }
  });
}

function waitForSection(id, timeoutMs = 10000) {
  return new Promise((resolve) => {
    const byId = document.getElementById(id);
    if (byId) return resolve(byId);

    const obs = new MutationObserver(() => {
      const el = document.getElementById(id);
      if (el) {
        obs.disconnect();
        resolve(el);
      }
    });
    obs.observe(document.documentElement, { childList: true, subtree: true });

    setTimeout(() => {
      obs.disconnect();
      resolve(null);
    }, timeoutMs);
  });
}

function fadeIn(el, ms) {
  el.style.opacity = '0';
  el.style.display = '';
  const start = performance.now();
  function step(ts) {
    const p = Math.min(1, (ts - start) / ms);
    el.style.opacity = String(p);
    if (p < 1) requestAnimationFrame(step);
  }
  requestAnimationFrame(step);
}

// ---- core
function initSlider(section) {
  if (!section || hasInitFlag(section)) return;

  const slides = Array.from(section.querySelectorAll(SELECTOR_SLIDE));
  if (!slides.length || slides.length === 1) return; // nada a fazer com 0/1

  setInitFlag(section);

  // marcação
  slides.forEach((s, i) => {
    s.classList.add('cs-slide');
    s.setAttribute('role', 'group');
    s.id = `cs-slide-${i}`;
    s.setAttribute('aria-label', `${i + 1} de ${slides.length}`);
    s.style.display = 'none';
    s.style.width = '100%';
  });

  // wrap
  const track = document.createElement('div');
  track.className = 'cs-slider-track';
  const slider = document.createElement('div');
  slider.className = 'cs-slider';
  slider.setAttribute('role', 'region');
  slider.setAttribute('aria-roledescription', 'carousel');
  slider.setAttribute('aria-label', 'Slideshow');
  slider.tabIndex = 0;

  const firstParent = slides[0].parentElement;
  slides.forEach((s) => track.appendChild(s));
  slider.appendChild(track);
  firstParent.appendChild(slider);

  // setas
  const prev = document.createElement('button');
  prev.className = 'cs-arrow cs-arrow--prev';
  prev.type = 'button';
  prev.setAttribute('aria-label', 'Anterior');
  prev.title = 'Anterior';
  prev.textContent = '‹';

  const next = document.createElement('button');
  next.className = 'cs-arrow cs-arrow--next';
  next.type = 'button';
  next.setAttribute('aria-label', 'Próximo');
  next.title = 'Próximo';
  next.textContent = '›';

  slider.append(prev, next);

  // dots
  const dotsWrap = document.createElement('div');
  dotsWrap.className = 'cs-dots';
  dotsWrap.setAttribute('role', 'tablist');
  dotsWrap.setAttribute('aria-label', 'Páginas do slideshow');

  const dots = slides.map((_, i) => {
    const dot = document.createElement('button');
    dot.className = 'cs-dot';
    dot.setAttribute('role', 'tab');
    dot.setAttribute('aria-selected', 'false');
    dot.setAttribute('aria-controls', `cs-slide-${i}`);
    dot.tabIndex = -1;
    dot.dataset.index = String(i);
    dotsWrap.appendChild(dot);
    return dot;
  });

  slider.appendChild(dotsWrap);

  // estado
  let index = 0;
  let timer = null;
  let hovering = false;
  let pageHidden = false;

  function show(i, animate = true) {
    index = (i + slides.length) % slides.length;

    slides.forEach((s) => {
      s.classList.remove('is-active');
      s.setAttribute('aria-hidden', 'true');
      s.style.display = 'none';
      s.style.opacity = '';
    });

    const current = slides[index];
    current.classList.add('is-active');
    current.setAttribute('aria-hidden', 'false');

    if (!animate || TRANSITION_MS <= 0) {
      current.style.display = '';
    } else {
      fadeIn(current, TRANSITION_MS);
    }

    dots.forEach((d) => {
      d.classList.remove('is-active');
      d.setAttribute('aria-selected', 'false');
      d.tabIndex = -1;
    });
    const activeDot = dots[index];
    activeDot.classList.add('is-active');
    activeDot.setAttribute('aria-selected', 'true');
    activeDot.tabIndex = 0;
  }

  function nextSlide() { show(index + 1); }
  function prevSlide() { show(index - 1); }

  function startAutoplay() {
    if (!AUTOPLAY) return;
    stopAutoplay();
    timer = setInterval(() => {
      if (!hovering && !pageHidden) nextSlide();
    }, AUTOPLAY_INTERVAL);
  }
  function stopAutoplay() {
    if (timer) clearInterval(timer);
    timer = null;
  }

  // eventos
  prev.addEventListener('click', prevSlide);
  next.addEventListener('click', nextSlide);

  dots.forEach((d) => {
    d.addEventListener('click', () => {
      const i = parseInt(d.dataset.index || '0', 10);
      show(i);
    });
  });

  slider.addEventListener('keydown', (e) => {
    if (e.key === 'ArrowLeft') {
      e.preventDefault(); prevSlide();
    } else if (e.key === 'ArrowRight') {
      e.preventDefault(); nextSlide();
    }
  });

  slider.addEventListener('mouseenter', () => { hovering = true; });
  slider.addEventListener('mouseleave', () => { hovering = false; });

  // visibility
  document.addEventListener('visibilitychange', () => {
    pageHidden = document.hidden === true;
  });

  // swipe
  let startX = null;
  slider.addEventListener('touchstart', (e) => {
    if (!e.touches || !e.touches.length) return;
    startX = e.touches[0].clientX;
  }, { passive: true });

  slider.addEventListener('touchend', (e) => {
    if (startX === null) return;
    const endX = (e.changedTouches && e.changedTouches[0].clientX) || startX;
    const dx = endX - startX;
    if (Math.abs(dx) > SWIPE_THRESHOLD) {
      if (dx > 0) prevSlide(); else nextSlide();
    }
    startX = null;
  });

  // init
  show(0, false);
  startAutoplay();

  slider.addEventListener('click', startAutoplay);
  slider.addEventListener('keydown', startAutoplay);
  slider.addEventListener('touchend', startAutoplay);
}

(async function boot() {
  const section = await waitForSection(SECTION_ID, 8000);

  if (section) {
    initSlider(section);
  } else {
    const candidate = Array.from(document.querySelectorAll('[id^="shopify-section-"]'))
      .find(sec => sec.querySelectorAll(SELECTOR_SLIDE).length > 1);
    if (candidate) initSlider(candidate);
  }

  onShopifySectionLoad(initSlider);
})();
